// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards > div{
    margin-top: 15px;
    margin-bottom: 15px;
}
.cards mat-card button{
   position: absolute;
   right: 0;
   top: 0;
   display: none;
}
.cards mat-card:hover button{
    display: block;
}

.cards .card-img{
    text-align: center;
}
.cards .card-img img{
    width: 70%;
}

.cards .phone{
    color: #DA512D;
}
.cards .card-footer{
    padding-top: 8px;
    padding-bottom: 8px;
    margin: 0 -16px -16px !important;
    background-color: transparent;
}
.card-footer .companyName{
    margin: 0;
}
.cards mat-card:hover .card-footer,
.cards mat-card.active .card-footer{
    background-color: rgba(0,0,0,0.03);
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBhbmllcy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksZ0JBQWdCO0lBQ2hCLG1CQUFtQjtBQUN2QjtBQUNBO0dBQ0csa0JBQWtCO0dBQ2xCLFFBQVE7R0FDUixNQUFNO0dBQ04sYUFBYTtBQUNoQjtBQUNBO0lBQ0ksY0FBYztBQUNsQjs7QUFFQTtJQUNJLGtCQUFrQjtBQUN0QjtBQUNBO0lBQ0ksVUFBVTtBQUNkOztBQUVBO0lBQ0ksY0FBYztBQUNsQjtBQUNBO0lBQ0ksZ0JBQWdCO0lBQ2hCLG1CQUFtQjtJQUNuQixnQ0FBZ0M7SUFDaEMsNkJBQTZCO0FBQ2pDO0FBQ0E7SUFDSSxTQUFTO0FBQ2I7QUFDQTs7SUFFSSxrQ0FBa0M7QUFDdEMiLCJmaWxlIjoiY29tcGFuaWVzLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY2FyZHMgPiBkaXZ7XG4gICAgbWFyZ2luLXRvcDogMTVweDtcbiAgICBtYXJnaW4tYm90dG9tOiAxNXB4O1xufVxuLmNhcmRzIG1hdC1jYXJkIGJ1dHRvbntcbiAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgIHJpZ2h0OiAwO1xuICAgdG9wOiAwO1xuICAgZGlzcGxheTogbm9uZTtcbn1cbi5jYXJkcyBtYXQtY2FyZDpob3ZlciBidXR0b257XG4gICAgZGlzcGxheTogYmxvY2s7XG59XG5cbi5jYXJkcyAuY2FyZC1pbWd7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuLmNhcmRzIC5jYXJkLWltZyBpbWd7XG4gICAgd2lkdGg6IDcwJTtcbn1cblxuLmNhcmRzIC5waG9uZXtcbiAgICBjb2xvcjogI0RBNTEyRDtcbn1cbi5jYXJkcyAuY2FyZC1mb290ZXJ7XG4gICAgcGFkZGluZy10b3A6IDhweDtcbiAgICBwYWRkaW5nLWJvdHRvbTogOHB4O1xuICAgIG1hcmdpbjogMCAtMTZweCAtMTZweCAhaW1wb3J0YW50O1xuICAgIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xufVxuLmNhcmQtZm9vdGVyIC5jb21wYW55TmFtZXtcbiAgICBtYXJnaW46IDA7XG59XG4uY2FyZHMgbWF0LWNhcmQ6aG92ZXIgLmNhcmQtZm9vdGVyLFxuLmNhcmRzIG1hdC1jYXJkLmFjdGl2ZSAuY2FyZC1mb290ZXJ7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgwLDAsMCwwLjAzKTtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/secure/companies/companies.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;GACG,kBAAkB;GAClB,QAAQ;GACR,MAAM;GACN,aAAa;AAChB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,6BAA6B;AACjC;AACA;IACI,SAAS;AACb;AACA;;IAEI,kCAAkC;AACtC;AACA,o9CAAo9C","sourcesContent":[".cards > div{\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n.cards mat-card button{\n   position: absolute;\n   right: 0;\n   top: 0;\n   display: none;\n}\n.cards mat-card:hover button{\n    display: block;\n}\n\n.cards .card-img{\n    text-align: center;\n}\n.cards .card-img img{\n    width: 70%;\n}\n\n.cards .phone{\n    color: #DA512D;\n}\n.cards .card-footer{\n    padding-top: 8px;\n    padding-bottom: 8px;\n    margin: 0 -16px -16px !important;\n    background-color: transparent;\n}\n.card-footer .companyName{\n    margin: 0;\n}\n.cards mat-card:hover .card-footer,\n.cards mat-card.active .card-footer{\n    background-color: rgba(0,0,0,0.03);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
